module.exports = __webpack_public_path__ + "img/Zartalogo@3x.17e81e28.png";